import React, { useEffect,  useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from "../FindModuleById";
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from "material-react-table";
import { Tooltip, IconButton, MenuItem } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import { loader_image } from "../_components/Imagepath";
import PropTypes from "prop-types";

const ProductionOutput = () => { 
  // layout
  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => setMenu((m) => !m);
// Refs for top scrollbar
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  // permissions
  const [permission, setPermission] = useState({});
  useEffect(() => {
    setPermission(FindModuleById(51));
  }, []);

   let season_id = localStorage.getItem("season_id");
  // filters form (top section)
  const [formData, setFormData] = useState({ 'season_id':season_id, shift: "", start_date: "", end_date: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  // table state
  const [data, setData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [pagination, setPagination] = useState(() => {
    const saved = localStorage.getItem("tablePagination");
    return saved ? JSON.parse(saved) : { pageIndex: 0, pageSize: 50 };
  });
  const [sorting, setSorting] = useState(() => {
    const saved = localStorage.getItem("tableSorting");
    return saved ? JSON.parse(saved) : [];
  });
  const [columnFilters, setColumnFilters] = useState(() => {
    const saved = localStorage.getItem("tableColumnFilters");
    return saved ? JSON.parse(saved) : [];
  });
  const [globalFilter, setGlobalFilter] = useState("");

  useEffect(() => {
    localStorage.setItem("tablePagination", JSON.stringify(pagination));
  }, [pagination]);
  useEffect(() => {
    localStorage.setItem("tableSorting", JSON.stringify(sorting));
  }, [sorting]);
  useEffect(() => {
    localStorage.setItem("tableColumnFilters", JSON.stringify(columnFilters));
  }, [columnFilters]);

  // ui state
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);

  // fetch: server-side pagination/sorting/filtering
  const fetchProductionsOutputData = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await axios.post(
        "/production-output/fetchProductionsOutputDataPagination",
        formData,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          params: {
            page: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            filters: columnFilters,
            sorting: sorting.map(({ id, desc }) => ({ column: id, order: desc ? "desc" : "asc" })),
            search: globalFilter,
          },
        }
      );

      // Backend shape per your controller
      const rows = response?.data?.data?.supply_chain_headers || [];
      const total = response?.data?.data?.totalRowCount || 0;
      setData(rows);
      setTotalRowCount(total);
    } catch (err) {
      console.error("Error fetching data", err);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [pagination, sorting, columnFilters, globalFilter, formData]);

  useEffect(() => {
    setIsRefetching(true);
    fetchProductionsOutputData().finally(() => setIsRefetching(false));
  }, [fetchProductionsOutputData]);

  const refetch = () => fetchProductionsOutputData();
// BarcodeNumberCell Component
const BarcodeNumberCell = ({ row }) => (
  <a href={`/production-output-view/${row.original.id}`}>
    {row.original.barcode_number}
  </a>
);
// ✅ PropTypes validation
BarcodeNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      barcode_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
  // columns (align with your earlier code/keys)
 const columns = [
  {
    header: 'Barcode Number',
    accessorFn: (row) => row.barcode_number,
    Cell: BarcodeNumberCell,size: 120, 
  },
    { accessorKey: "calibre", header: "Calibre",size: 80, },
    { accessorKey: "Product", header: "Product" ,size: 200,},
    { accessorKey: "lot_number_total", header: "Lot Number" ,size: 80},
    { accessorKey: "date_time", header: "Date Time" },
    { accessorKey: "shift", header: "Shift",size: 50, },
    { accessorKey: "shift_date", header: "Shift Date",size: 80,  },
    { accessorKey: "po_order", header: "Order Number" },
    { accessorKey: "pallet_type_title", header: "Pallet Type",size: 80 },
    { accessorKey: "total_gross_weight", header: "Gross Weight",size: 80 },
    { accessorKey: "total_weight", header: "Net Weight",size: 50 },
    { accessorKey: "total_boxes", header: "Number Of Boxes" ,size: 50},
    { accessorKey: "packaging_type_title", header: "Package Type" ,size: 100},
    { accessorKey: "location_name", header: "Location",size: 100 },
    {
      header: "Created By",
      accessorFn: (row) => (row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : ""),size: 100 
    },
    {
      header: "Updated By",
      accessorFn: (row) => (row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : ""),size: 100 
    },
 ];

  // Actions
  const deleteItem = (id) => {
    Swal.fire({
      title: "Do you really want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "DELETE",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`/production-output/delete/${season_id+'-'+id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
              Swal.fire("Deleted!", "Your Record has been deleted.", "success");
              refetch();
            }
          })
          .catch((error) => console.error(error));
      }
    });
  };

  const editItem = (id) => {
    window.location.href = "/production-output-edit/" + id;
  };

  const printPalletLabel = async (item) => {
    const id = item.id;
    try {
      // label
      const res1 = await axios.get(`/production-output/pdf/${season_id+'-'+id}`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      const blob1 = new Blob([res1.data], { type: "application/pdf" });
      const link1 = document.createElement("a");
      link1.href = URL.createObjectURL(blob1);
      link1.download = `Pallet Label - ${item.barcode_number}.pdf`;
      link1.click();

      // fiche (conditional)
      if (item.pallet_type === 3) {
        const res2 = await axios.get(`/production_output-fiche-de-pallete/pdf/${season_id+'-'+id}`, {
          responseType: "blob",
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        });
        const blob2 = new Blob([res2.data], { type: "application/pdf" });
        const link2 = document.createElement("a");
        link2.href = URL.createObjectURL(blob2);
        link2.download = `Fiche De Pallete - ${item.barcode_number}.pdf`;
        link2.click();
      }
    } catch (e) {
      console.error("Error downloading PDFs", e);
    }
  };

  // download excel
  const objectToQueryString = (obj) =>
    Object.keys(obj)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
      .join("&");
  const downloadExcel = () => {
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/production-output/listing-excel?${queryString}`, "_blank");
  };

  // Tabs (optional group-by sections)
  const [dataGroupByShift, setDataGroupByShift] = useState([]);
  const [dataGroupByPallet, setDataGroupByPallet] = useState([]);

  const fetchGroupByShiftDateData = async () => {
    try {
      const response = await axios.post("/production-output/fetchGroupByShiftDateData", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) setDataGroupByShift(response.data.data.productions_groupby || []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchGroupByPalletTypeData = async () => {
    try {
      const response = await axios.post("/production-output/fetchGroupByPalletTypeData", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) setDataGroupByPallet(response.data.data.reports_pallet_types || []);
    } catch (e) {
      console.error(e);
    }
  };
   const ShiftDateCell = ({ row }) => (
    <a href={`/production-output-groupby/${row.original.shift_date}_${row.original.location}`}>
      {row.original.shift_date}
    </a>
  );
  
  const LocationCell = ({ row }) => (
    <a href={`/production-output-groupby/${row.original.shift_date}_${row.original.location}`}>
      {row.original.location_name ? row.original.location_name.title : ""}
    </a>
  );
  
  // ✅ Add PropTypes validation
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
       // shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  
  LocationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
       // shift: PropTypes.string.isRequired,
        location_name: PropTypes.shape({
          title: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };
  const columnsGroupByShift = [
    {
      header: 'Shift Date',
      accessorFn: (row) => `${row.shift_date} `,
      Cell: ShiftDateCell, // ✅ Using the corrected component
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ""} `,
      Cell: LocationCell, // ✅ Using the corrected component
    },
       {
      accessorKey: 'total_net_weight', //normal accessorKey
      header: 'Total Net Weight',
    },
    {
      accessorKey: 'count_pallets', //normal accessorKey
      header: 'Total Pallets',
    },
  ];
   // ✅ Define row.original PropTypes
const rowOriginalShape = PropTypes.shape({
  pallet_type_title: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
  }),
  num_pallets: PropTypes.number.isRequired,
  net_weight_total: PropTypes.number.isRequired,
});

// ✅ Define row PropTypes
const rowShape = PropTypes.shape({
  original: rowOriginalShape.isRequired,
});
// ✅ Pallet Type Cell Component
const PalletTypeCell = ({ row }) => {
  const { pallet_type_title } = row.original;
  
  return (
    <a
      href={pallet_type_title?.id ? `/production-output-pallettype/${pallet_type_title.id}` : "#"}
      className=""
    >
      {pallet_type_title?.title || ""}
    </a>
  );
};
PalletTypeCell.propTypes = {
  row: rowShape.isRequired,
};
  const columnsGroupByPallet = [
  {
    header: 'Pallet Type',
    Cell: PalletTypeCell,
  },
  {
    accessorKey: 'num_pallets',
    header: 'Number of Pallets',
  },
  {
    accessorKey: 'net_weight_total',
    header: 'Total Net Weight',
  },
];

  // Sync scrollbars for main table
  useEffect(() => {
    const syncScrollbars = () => {
      const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');

      if (tableContainer && topScroll && topScrollContent) {
        topScrollContent.style.width = `${tableContainer.scrollWidth}px`;
        
        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScroll.scrollLeft;
        };
        
        const handleTableScroll = () => {
          topScroll.scrollLeft = tableContainer.scrollLeft;
        };

        topScroll.addEventListener('scroll', handleTopScroll);
        tableContainer.addEventListener('scroll', handleTableScroll);

        return () => {
          topScroll.removeEventListener('scroll', handleTopScroll);
          tableContainer.removeEventListener('scroll', handleTableScroll);
        };
      }
    };

    const timer = setTimeout(syncScrollbars, 100);
    return () => clearTimeout(timer);
  }, [data, isLoading]);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Production Output</li>
                  </ul>
                </div>
                <div className="col-auto">
                  {permission?.add == 1 && (
                    <Link to="/production-output-add" className="btn btn-primary me-1">
                      <i className="fas fa-plus"></i>
                    </Link>
                  )}
                  &nbsp;&nbsp;
                  {permission?.list == 1 && (
                    <button className="btn btn-primary" onClick={downloadExcel}>
                      <i className="fa fa-file-excel-o"></i> <i className="fa fa-download"></i>
                      <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} alt="loader" />
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Filters */}
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Shift:</label>
                        <select
                          className="form-control form-white"
                          data-placeholder="Select Shift"
                          name="shift"
                          value={formData.shift}
                          onChange={handleChange}
                        >
                          <option value=""> Select </option>
                          <option value="1">01</option>
                          <option value="2">02</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>
                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="button" className="btn btn-primary" onClick={refetch}>
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/production-output" className="btn btn-primary me-1">
                          <i className="fa fa-times"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Tabs */}
            <div className="row">
              <div className="col-sm-12">
                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        {permission?.list == 1 && (
                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-groupby" data-bs-toggle="tab" onClick={fetchGroupByShiftDateData}>
                                  Group By Shift Date And Location
                                </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-pallets" data-bs-toggle="tab" onClick={fetchGroupByPalletTypeData}>
                                  Group By Pallet Type
                                </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link active" href="#listing-all" data-bs-toggle="tab" onClick={refetch}>
                                  Productions Output
                                </a>
                              </li>
                            </ul>

                            <div className="tab-content">
                              {/* Group By Shift Date */}
                              <div className="tab-pane" id="listing-groupby">
                                <div className="row" id="listing-followup-groupby">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnsGroupByShift} data={dataGroupByShift} enableColumnOrdering enablePinning />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Group By Pallet Type */}
                              <div className="tab-pane" id="listing-pallets">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnsGroupByPallet} data={dataGroupByPallet} enableColumnOrdering enablePinning />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Productions Output (main) */}
                              <div className="tab-pane show active" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div 
                                          ref={topScrollRef} 
                                          className="top-scrollbar"
                                          style={{
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                            marginBottom: '10px',
                                            height: '20px'
                                          }}
                                        >
                                          <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                        </div>
                                        <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                          <MaterialReactTable
                                            columns={columns}
                                            data={data}
                                            manualFiltering
                                            manualPagination
                                            manualSorting
                                            muiToolbarAlertBannerProps={
                                              isError ? { color: "error", children: "Error loading data" } : undefined
                                            }
                                            onColumnFiltersChange={setColumnFilters}
                                            onGlobalFilterChange={setGlobalFilter}
                                            onSortingChange={setSorting}
                                            onPaginationChange={setPagination}
                                            renderTopToolbarCustomActions={() => (
                                              <Tooltip arrow title="Refresh Data">
                                                <IconButton onClick={refetch}>
                                                  <RefreshIcon />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            rowCount={totalRowCount}
                                            pageCount={Math.ceil(totalRowCount / pagination.pageSize) || 0}
                                            enableDebug={true}
                                            state={{
                                              columnFilters,
                                              globalFilter,
                                              isLoading,
                                              pagination,
                                              showAlertBanner: isError,
                                              showProgressBars: isRefetching,
                                              sorting,
                                            }}
                                            enableRowActions
                                            renderRowActionMenuItems={({ row }) => [
                                              permission?.list == 1 && (
                                                <MenuItem key="view" onClick={() => printPalletLabel(row.original)}>
                                                  Print Pallet Label
                                                  <img id="loader-image2" className="loader-image loader-hide" src={loader_image} alt="Loading" />
                                                </MenuItem>
                                              ),
                                              permission?.update == 1 && (
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>
                                              ),
                                              permission?.delete == 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionOutput;
